<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-20 09:19:56
 * @LastEditTime: 2019-10-09 17:24:08
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div id="page_Container">
        <!-- <navigation title="付款成功" :left-arrow="true"/> -->
        <div class="page">
            <div id="main-container" class="main-container">
                <div class='content'>
                <img src="../assets/img/goods/paysuccess.png" alt="">
                <div class="suctip1">付款成功</div>
                <div class="suctip2">感谢您的购买～</div>
                <div class="returnbtn" @click="gohome">返回主页</div>
                <!-- <div class="returnbtn lottery" @click="goLottery">去抽奖</div> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
        };
    },
    esvReady: function() {
        document.title = '付款成功';
    },
    esvBack(backFn) {
        // 阻止系统返回键
        backFn && backFn(true);
        this.esvBackPage(2);
    },
    methods: {
        // goLottery() {
        //     window.location.href = 'https://hd.faisco.cn/18602128/cifh5-Auxq8cZe-33D-b5A/load.html?style=75&editQrcode=true';
        // },
        gohome() {
            this.esvBackPage(8);
            // this.esvOpenPage('OPHomenew');
            // this.esvReloadPage('OPHomenew');
        }
    }
};
</script>
<style lang="scss" scoped>
.content{
    margin-top: 30px;
    text-align: center;
    img{
        width: 65px;
        height: 65px;
    }
    .suctip1{
        color: #333;
        font-size: 20px;
        margin-top: 16px;
        margin-bottom: 8px;
    }
    .suctip2{
        color: #999;
        font-size: 14px;
    }
    .returnbtn{
        width: 87%;
        height: 44px;
        line-height: 44px;
        color: #fff;
        font-size: 14px;
        background: $primary-color;
        border-radius: 22px;
        margin: 56px auto 0;
        &.lottery {
            margin: 10px auto;
            color: $primary-color;
            background-color: #fff;
            // font-weight: 700;
        }
    }
}
</style>
